import React from "react";
import './CustomModal.css';
import { Typography } from "antd";

interface CustomModalProps{
    show: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title: string;
    hideXButton?: boolean | undefined;
    showRedBorder?: boolean | undefined;
    parentRef?: React.RefObject<HTMLElement>;
}

const { Text } = Typography;

const CustomModal : React.FC<CustomModalProps> = ({ parentRef, show, onClose, children, title, hideXButton = false, showRedBorder = false}) => {
    
    if (!show) return null;

    const overlayStyle: React.CSSProperties = {
        border: showRedBorder ? '16px solid red' : 'none',
        ...(parentRef?.current
            ? {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1100, 
            }
            : {})
    };
  
    return (
      <div
      style={overlayStyle}
      className="modal-overlay" onClick={onClose}>
        <div className='modal-container' onClick={e => e.stopPropagation()}>
          <div className={'modal-header'}>
            <button className="modal-close-button" onClick={onClose}>
              {
                !hideXButton && <Text
                  style={{ fontSize:'24px' }}>
                    &times;
                  </Text>
              }
            </button>
            <div>
              <Text style={{ fontWeight:'bold'}}>{title}</Text>
            </div>
          </div>
          <div className={'modal-content'}>
            {children}
          </div>
        </div>
      </div>
    );
};

export default CustomModal;

